export enum SampleType {
    Scat = 1,
    Blood = 2,
    Urine = 3,
    Hair = 4,
    Tissue = 5,
    Saliva = 6,
    ScentMarking = 7,
}